import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { RouterModule } from '@angular/router';
// TODO:Spartacus - // TODO:Spartacus - Variable asmTranslations has been removed and is no longer part of the public API. 
import { asmTranslationChunksConfig, asmTranslationsCs, asmTranslationsDe, asmTranslationsEn, asmTranslationsEs, asmTranslationsEs_CO, asmTranslationsFr, asmTranslationsHi, asmTranslationsHu, asmTranslationsId, asmTranslationsIt, asmTranslationsJa, asmTranslationsKo, asmTranslationsPl, asmTranslationsPt, asmTranslationsRu, asmTranslationsZh, asmTranslationsZh_TW } from '@spartacus/asm/assets';
import { AsmRootModule, ASM_FEATURE, AsmEnablerService } from '@spartacus/asm/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { PageLayoutComponent, CmsPageGuard } from '@spartacus/storefront';
import { KbAsmEnablerService } from 'src/app/services/feature/kb-asm/store/service/kb-asm-enabler.service';
import { KbAsmService } from 'src/app/services/feature/kb-asm/store/service/kb-asm.service';

@NgModule({
  declarations: [],
  imports: [
    AsmRootModule,
    RouterModule.forChild([
      {
        path: 'samlsinglesignon/saml/SSO',
        data: { pageLabel: '/samlsinglesignon' },
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard],
      },
      {
        path: 'samlsinglesignon/saml/sso',
        data: { pageLabel: '/samlsinglesignon' },
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard],
      },
    ]),
  ],
  providers: [
    {
      provide: AsmEnablerService,
      useExisting: KbAsmEnablerService,
    },
    provideAppInitializer(() => {
      const initializerFn = (kbAsmFactory)(inject(KbAsmService));
      return initializerFn();
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [ASM_FEATURE]: {
          module: () => import('../asm/asm.module').then((m) => m.KbAsmModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        fallbackLang: 'en',
        resources: {
          cs: asmTranslationsCs,
          de: asmTranslationsDe,
          en: asmTranslationsEn,
          es: asmTranslationsEs,
          es_CO: asmTranslationsEs_CO,
          fr: asmTranslationsFr,
          hi: asmTranslationsHi,
          hu: asmTranslationsHu,
          id: asmTranslationsId,
          it: asmTranslationsIt,
          ja: asmTranslationsJa,
          ko: asmTranslationsKo,
          pl: asmTranslationsPl,
          pt: asmTranslationsPt,
          ru: asmTranslationsRu,
          zh: asmTranslationsZh,
          zh_TW: asmTranslationsZh_TW,
        },
        chunks: asmTranslationChunksConfig,
      },
    }),
  ],
})
export class AsmFeatureModule { }
export function kbAsmFactory(kbAsmService: KbAsmService) {
  const isReady = () => {
    kbAsmService.redirectToSSO();
  };
  return isReady;
}
